import { IonContent, IonGrid, IonRow, IonCol } from "@ionic/react";
import React, { useEffect, useState, PureComponent } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router";
import { AppHeader } from "../../../../components/Header/AppHeader";
import { getEntries, setCurrentView } from "../../../../services/users";
import ChartsToileting from "./ChartsToileting";
import ChartsSleep from "./ChartsSleep";
import ChartsEating from "./ChartsEating";
import UserHeader from "../components/UserHeader";

//https://github.com/recharts/recharts

export interface RouteParams {
  id: string;
}

interface props {
  usersData: any;
  userDetails: any;
  setCurrentView: any;
}

const UserCharts: React.FC<props> = ({
  usersData,
  userDetails,
  setCurrentView,
}) => {
  let { id } = useParams<RouteParams>();

  const [user, setUser] = useState<any>({});
  const [entries, setEntries] = useState<any>({});
  const [labels, setLabels] = useState<any>([]);

  useEffect(() => {
    if (usersData && usersData[id]) {
      setUser(usersData[id]);
      setCurrentView(id);
    }
    //eslint-disable-next-line
  }, [usersData]);

  useEffect(() => {
    if (user && user.id) {
      getEntries(user.id).then((data: any) => {
        let validEntries = data;

        // A check to ensure that the sleep entry is complete. If not, it is removed from the list.
        if (user.study === "sleep") {
          //console.log(validEntries);
          validEntries = Object.values(data).filter((el: any) => {
            //console.log(el);
            return el.date !== "";
          });
        }
        setEntries(validEntries);
      });
      createLabels();
    }
  }, [user]);

  const createLabels = () => {
    let result: any = [];

    user.dates.forEach((el: any) => {
      let phase = user.phases.find((ph: any) => ph.pID === el.phase);
      result[el.dateField] = { phaseName: phase.pLabel };
    });

    setLabels(result);
  };

  return (
    <>
      <AppHeader title={user && user.displayName} />
      <IonContent fullscreen className="ion-padding">
        <UserHeader user={user} isAdmin={userDetails.isAdmin} />
        <IonGrid>
          {user.study === "toilet" && (
            <ChartsToileting entries={entries} labels={labels} />
          )}
          {user.study === "sleep" && (
            <ChartsSleep entries={entries} labels={labels} />
          )}
          {user.study === "eat" && (
            <ChartsEating entries={entries} labels={labels} />
          )}
        </IonGrid>
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  userDetails: state.user.userDetails,
  usersData: state.user.users,
});

const mapDispatchToProps = { setCurrentView };

export default connect(mapStateToProps, mapDispatchToProps)(UserCharts);
